import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { BsArrowLeft, BsInfoCircle, BsBoxArrowInRight, BsBoxArrowRight, BsSave, BsArrowRepeat } from "react-icons/bs";
import { storeJadwal } from "../services/jadwalService";

const DAYS = ["Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu", "Minggu"];
const emptySchedule = () => Object.fromEntries(DAYS.map((day) => [day, { masuk: "", keluar: "" }]));

function JadwalPage() {
  const navigate = useNavigate();
  const [schedule, setSchedule] = useState(emptySchedule);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const updateTime = (day, field, value) => {
    setMessage("");
    setSchedule((current) => ({ ...current, [day]: { ...current[day], [field]: value } }));
  };

  const resetDay = (day) => {
    setSchedule((current) => ({ ...current, [day]: { masuk: "", keluar: "" } }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const selectedDays = DAYS.filter((day) => schedule[day].masuk || schedule[day].keluar);
    if (!selectedDays.length) {
      setMessage("Isi minimal satu hari untuk disimpan.");
      return;
    }
    const incompleteDay = selectedDays.find((day) => !schedule[day].masuk || !schedule[day].keluar);
    if (incompleteDay) {
      setMessage(`Jam masuk dan keluar ${incompleteDay} harus diisi keduanya.`);
      return;
    }
    const invalidDay = selectedDays.find((day) => schedule[day].keluar <= schedule[day].masuk);
    if (invalidDay) {
      setMessage(`Jam keluar ${invalidDay} harus lebih lambat dari jam masuk.`);
      return;
    }

    setLoading(true);
    setMessage("");
    const errors = [];
    try {
      for (const day of selectedDays) {
        const result = await storeJadwal({
          hari: day,
          jamMasuk: schedule[day].masuk,
          jamKeluar: schedule[day].keluar,
        });
        if (!result.success) errors.push(`${day}: ${result.message}`);
      }
      if (errors.length) {
        setMessage(errors.join("\n"));
        return;
      }
      navigate("/dashboard", { replace: true });
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="student-schedule-page">
      <header className="student-schedule-topbar">
        <button className="student-schedule-back" type="button" onClick={() => navigate(-1)} aria-label="Kembali">
          <BsArrowLeft />
        </button>
        <div>
          <h1>Isi Jadwal</h1>
          <p>Atur jam praktik PKL setiap hari</p>
        </div>
      </header>

      <section className="app-content">
        <div className="student-schedule-info mb-3">
          <BsInfoCircle aria-hidden="true" />
          <span>Pilih jam masuk dan keluar pada hari yang berlaku. Minimal isi satu hari sebelum menyimpan.</span>
        </div>
        {message && <div className="alert alert-danger small" role="alert" style={{ whiteSpace: "pre-line" }}>{message}</div>}

        <form onSubmit={handleSubmit}>
          {DAYS.map((day, index) => (
            <section className="student-schedule-day" key={day}>
              <div className="student-schedule-day-head">
                <span className="student-schedule-day-number">{index + 1}</span>
                <span className="student-schedule-day-name">{day}<small className="d-block fw-normal opacity-75">Jadwal praktik</small></span>
                <button className="btn btn-link student-schedule-reset" type="button" onClick={() => resetDay(day)} aria-label={`Reset jadwal ${day}`}>
                  <BsArrowRepeat className="me-1" />Reset
                </button>
              </div>
              <div className="student-schedule-times">
                <div className="student-schedule-time">
                  <label htmlFor={`masuk-${day}`}><BsBoxArrowInRight /> Jam masuk</label>
                  <input id={`masuk-${day}`} className="form-control" type="time" value={schedule[day].masuk} onChange={(event) => updateTime(day, "masuk", event.target.value)} />
                </div>
                <div className="student-schedule-time">
                  <label htmlFor={`keluar-${day}`}><BsBoxArrowRight /> Jam keluar</label>
                  <input id={`keluar-${day}`} className="form-control" type="time" value={schedule[day].keluar} onChange={(event) => updateTime(day, "keluar", event.target.value)} />
                </div>
              </div>
            </section>
          ))}
          <div className="student-schedule-savebar">
            <button className="btn btn-primary w-100" type="submit" disabled={loading}>
              {loading ? <><span className="spinner-border spinner-border-sm me-2" />Menyimpan jadwal...</> : <><BsSave className="me-2" />Simpan Jadwal</>}
            </button>
          </div>
        </form>
      </section>
    </main>
  );
}

export default JadwalPage;
